export default __webpack_public_path__ + "static/media/logo-globe.9c559e6a.png";